import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaMinusCircle } from "react-icons/fa";
import styled from "styled-components";
import { ItemModel } from "../../../../../shared/game/ItemModel";
import { ImageUsecase } from "../../../../../shared/resources/ImageModel";
import { ErrorType } from "../../../../stores/editor/ErrorNotification";
import { editorStore } from "../../../../stores/EditorStore";
import { errorStore } from "../../../../stores/ErrorStore";
import { gameStore } from "../../../../stores/GameStore";
import { imageStore } from "../../../../stores/ImageStore";
import { itemStore } from "../../../../stores/ItemStore";
import { undoableCreateItem } from "../../../../stores/undo/operation/ItemEditorCreateItemOp";
import { undoableDeleteItem } from "../../../../stores/undo/operation/ItemEditorDeleteItemOp";
import { ImageSelectionWithUpload } from "../../../images/ImageSelectionWithUpload";
import { AutoResizeTextareaFullWidth } from "../../../shared/AutoResizeTextarea";
const Button = styled.button.withConfig({
  displayName: "ItemConfigurator__Button",
  componentId: "sc-1u1n3lh-0"
})(["min-width:32px;min-height:24px;"]);
const DeleteButton = styled(Button).withConfig({
  displayName: "ItemConfigurator__DeleteButton",
  componentId: "sc-1u1n3lh-1"
})(["color:#DD0000;"]);
const ConfiguratorContainer = styled.table.withConfig({
  displayName: "ItemConfigurator__ConfiguratorContainer",
  componentId: "sc-1u1n3lh-2"
})(["background:white;border:1px solid darkgray;padding:3px;margin:3px;"]);
const ImageField = styled.img.withConfig({
  displayName: "ItemConfigurator__ImageField",
  componentId: "sc-1u1n3lh-3"
})(["margin:auto;max-width:85px;max-height:85px;padding:9px;"]);
export const ItemConfigurator = observer(props => {
  const {
    t
  } = useTranslation();
  const {
    selectedItem
  } = itemStore;
  const [newItemId, setNewItemId] = useState("");

  const createItem = () => {
    if (itemStore.getItem(newItemId)) {
      errorStore.addError(ErrorType.General, "editor.item_id_already_exists", {
        suggestion: newItemId + "2"
      });
      return;
    }

    const newItem = new ItemModel({
      id: newItemId,
      tags: [],
      moduleOwner: editorStore.sessionModuleId
    });
    undoableCreateItem(newItem);
  };

  const deleteItem = () => {
    if (!selectedItem) {
      console.error("Item could not be deleted because it was null or undefined.");
      return;
    }

    undoableDeleteItem(selectedItem);
    props.closeEditor();
  };

  function updateName(newName) {
    selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name.set(gameStore.languageKey, newName);
  }

  function updateTags(newTags) {
    selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.setTags(newTags);
  }

  function updateDescription(newDescription) {
    selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description.set(gameStore.languageKey, newDescription);
  }

  return /*#__PURE__*/React.createElement(ConfiguratorContainer, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.item_id")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    disabled: !!selectedItem,
    type: "text",
    value: selectedItem ? selectedItem.id : newItemId,
    onChange: ({
      target
    }) => setNewItemId(target.value)
  }), "\xA0", !selectedItem && /*#__PURE__*/React.createElement(Button, {
    onClick: createItem
  }, t("editor.create_item")), selectedItem && /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: deleteItem
  }, /*#__PURE__*/React.createElement(FaMinusCircle, null), " ", t("editor.tile_asset_delete")))), selectedItem && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.item_name")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name.get(gameStore.languageKey, false),
    placeholder: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name.get(gameStore.languageKey, true),
    onChange: ({
      target
    }) => updateName(target.value)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.item_tags")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.tags.join(" "),
    onChange: ({
      target
    }) => updateTags(target.value.split(" "))
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.item_description")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AutoResizeTextareaFullWidth, {
    value: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description.get(gameStore.languageKey, false),
    placeholder: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.description.get(gameStore.languageKey, true),
    onChange: ({
      target
    }) => updateDescription(target.value)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.item_image")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImageField, {
    src: imageStore.getImageUrl(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.itemImageId)
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t("editor.item_all_images")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ImageSelectionWithUpload, {
    selectedImageId: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.itemImageId,
    selectedImageIdSetter: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.setItemImageId.bind(selectedItem),
    imageUsecase: ImageUsecase.Item
  }))))));
});